<template>
  <div class="m-mobile-subnav">
    <button
      :id="buttonId"
      type="button"
      class="m-mobile-subnav__header"
      :aria-expanded="`${open}`"
      :aria-controls="contentId"
      @click.stop="toggle"
    >
      <div class="m-mobile-subnav__header-content">
        <slot />
      </div>
      <MIcon :icon="open ? 'chevron-up' : 'chevron-down'" size="h4" />
    </button>

    <MTransition type="expand">
      <ul
        v-show="open"
        :id="contentId"
        class="m-mobile-subnav__body"
        :aria-labelledby="buttonId"
      >
        <MMobileNavItem
          v-for="item in items"
          :key="`${item.text}-mobile`"
          :active="item.active"
          :tag="item.tag || 'a'"
          :href="item.href"
          :data-qa-locator="item.qaLocator + '-mobile'"
          @click.native="$emit('item-selected')"
        >
          <MSpacing left="xs">
            <slot name="item-template" :subnav-item="item">
              {{ item.text }}
            </slot>
          </MSpacing>
        </MMobileNavItem>
      </ul>
    </MTransition>
  </div>
</template>

<script lang="ts">
import { useId, ref } from 'vue'

import MSpacing from '../../layout/Spacing/MSpacing.vue'
import MTransition from '../../layout/Transition/MTransition.vue'
import MIcon from '../../typography/Icon/MIcon.vue'
import MMobileNavItem from '../MobileNav/MMobileNavItem.vue'
export default {
  name: 'MobileSubnav',
  components: {
    MMobileNavItem,
    MSpacing,
    MTransition,
    MIcon,
  },
  props: {
    /**
     * Sub navigation items.
     * Object shape matches mobile nav item props.
     */
    items: {
      type: Array,
      required: true,
    },
  },
  emits: ['item-selected'],
  setup() {
    const id = useId()
    const open = ref(false)

    return {
      buttonId: `m-mobile-subnav-button-${id}`,
      contentId: `m-mobile-subnav-content-${id}`,
      open,
    }
  },
  methods: {
    toggle() {
      this.open = !this.open
    },
  },
}
</script>

<style lang="scss" scoped>
@use '../../../sass/framework/mixins/buttons';
@use '../../../sass/framework/mixins/hover';

.m-mobile-subnav {
  border-bottom: 1px solid var(--skin-separator-color);
  &__header {
    @include buttons.button;
    @include hover.hover-transition(background-color);
    color: var(--skin-color);
    font-size: var(--typography-paragraph-small-font-size);
    line-height: inherit;
    padding: calc(var(--spacing-24) - var(--spacing-4)) var(--spacing-24);
    text-align: left;
    width: 100%;
    &-content {
      flex: 1 1 auto;
    }

    @include hover.hover-styles {
      background-color: var(--skin-clickable-background-hover);
    }
  }
  //remove the border from the nav items when the subnav is open
  &__body {
    :deep(.m-mobile-nav__item) {
      border-bottom: 0;
    }
  }
}
</style>
